<template>
  <div>
    <TheHeader />
    <section class="main">
      <div class="container pt-5">
        <div class="row">
          <div class="col">
            <h3>{{ $store.state.produto.nome }}</h3>
            <hr />
          </div>
        </div>
        <Breadcrumb :list="list" />
        <div class="row mt-4">
          <transition mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </section>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  name: "Produto",
  components: {
    TheHeader,
    TheFooter,
    Breadcrumb,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    sendData() {
      console.log(this.name.user);
    },
  },
  watch: {
    "$store.state.breadcrumb"(newValue) {
      this.list = [
        {
          title: "Home",
          link: "/",
        },
      ];
      newValue.forEach((e) => {
        var item = {
          title: e.nome,
          link: e.link ? e.link : "",
        };
        this.list.push(item);
        if (e.produto) {
          this.produto = e.produto;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
